






















import { computed, defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    title: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    showSkeleton: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
    },
  },
  emits: ['select'],
  setup(props) {
    const componentProps = computed(() => {
      if (props.url) {
        return {
          component: 'NuxtLink',
          props: { to: props.url },
        }
      }
      return { component: 'div' }
    })
    return { componentProps }
  },
})
